module.exports = __webpack_public_path__ + "static/media/kreisverkehr.a8581215.svg";